const tasks = [
  'понять интересы сторон;',
  'сохранить управляемость ситуации;',
  'отстоять принципиально важные позиции;',
  'найти пространство для договорённости;',
  'определить границы допустимого;',
  'зафиксировать ответственность;',
  'сохранить рабочие отношения там, где это необходимо;',
  'добиться результата для бизнеса.',
];

export default function NegotiationAsTool() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Главная компетенция руководителя — не «победить» в переговорах
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Сильный руководитель не стремится выиграть каждый спор. Его задача:
        </p>

        <div className="grid sm:grid-cols-2 gap-3 max-w-4xl mx-auto mb-12">
          {tasks.map((t, i) => (
            <div key={i} className="flex items-start gap-2.5 bg-white rounded-lg border border-gray-200 p-4 hover:border-teal-300 transition-colors">
              <i className="ri-checkbox-circle-line text-teal-600 mt-0.5 flex-shrink-0"></i>
              <span className="text-sm text-gray-700 leading-relaxed">{t}</span>
            </div>
          ))}
        </div>

        <div className="grid sm:grid-cols-2 gap-5 max-w-4xl mx-auto">
          <div className="bg-gray-900 rounded-2xl p-6 md:p-8 text-center">
            <p className="text-gray-400 text-xs uppercase tracking-wider mb-3">Неправильный фокус</p>
            <p className="text-base md:text-lg text-white leading-relaxed font-semibold">
              «Я должен продавить свою позицию»
            </p>
          </div>
          <div className="bg-teal-600 rounded-2xl p-6 md:p-8 text-center">
            <p className="text-teal-100 text-xs uppercase tracking-wider mb-3">Правильный фокус</p>
            <p className="text-base md:text-lg text-white leading-relaxed font-semibold">
              «Я должен добиться необходимого результата, сохранив контроль над ситуацией»
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}